import React, { Fragment, useEffect, useState } from "react";
import { allOrdersAction, chartDataAction } from "../../redux/actions/orderActions";
import { useDispatch, useSelector } from "react-redux";
import GrossNetProfit from "./GrossNetProfit";
import { allProductsAction } from "../../redux/actions/productActions";
import Products from "./Products";
import OrdersPage from "./Orders";
import DateFilter from "../../elements/DateFilter";

const Dashboard = () => {

  const dispatch = useDispatch()

  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  const [dateFrom, setDateFrom] = useState(firstDay);
  const [dateTo, setDateTo] = useState(today);

  const { chart } = useSelector(state => state.chartData);
  const { loading, products } = useSelector((state) => state.Products)
  const { loading: orderLoading, orders } = useSelector((state) => state.orders)
  const { user } = useSelector((state) => state.verifyEmailStore)

  const { currentPeriod, previousPeriod } = chart || {};

  const statusStyles = {
    ORDERED: { gradient: "from-blue-50/50 to-white", border: "border-blue-100/80", text: "text-blue-600 dark:text-blue-300", icon: "fa-cart-shopping", iconColor: "text-blue-300 dark:text-blue-200", iconBg: "dark:bg-blue-500/12" },
    REVIEWED: { gradient: "from-purple-50/50 to-white", border: "border-purple-100/80", text: "text-purple-600 dark:text-purple-300", icon: "fa-star", iconColor: "text-purple-300 dark:text-purple-200", iconBg: "dark:bg-purple-500/12" },
    DELIVERED: { gradient: "from-emerald-50/50 to-white", border: "border-emerald-100/80", text: "text-emerald-600 dark:text-emerald-300", icon: "fa-truck", iconColor: "text-emerald-300 dark:text-emerald-200", iconBg: "dark:bg-emerald-500/12" },
    ON_HOLD: { gradient: "from-amber-50/50 to-white", border: "border-amber-100/80", text: "text-amber-600 dark:text-amber-300", icon: "fa-pause", iconColor: "text-amber-300 dark:text-amber-200", iconBg: "dark:bg-amber-500/12" },
    REFUNDED: { gradient: "from-rose-50/50 to-white", border: "border-rose-100/80", text: "text-rose-600 dark:text-rose-300", icon: "fa-arrow-rotate-left", iconColor: "text-rose-300 dark:text-rose-200", iconBg: "dark:bg-rose-500/12" },
    COMMISSIONED: { gradient: "from-indigo-50/50 to-white", border: "border-indigo-100/80", text: "text-indigo-600 dark:text-indigo-300", icon: "fa-money-bill-wave", iconColor: "text-indigo-300 dark:text-indigo-200", iconBg: "dark:bg-indigo-500/12" },
    COMPLETED: { gradient: "from-teal-50/50 to-white", border: "border-teal-100/80", text: "text-teal-600 dark:text-teal-300", icon: "fa-check-double", iconColor: "text-teal-300 dark:text-teal-200", iconBg: "dark:bg-teal-500/12" },
    REVIEW_DELETED: { gradient: "from-red-50/50 to-white", border: "border-red-100/80", text: "text-red-600 dark:text-red-300", icon: "fa-trash-can", iconColor: "text-red-300 dark:text-red-200", iconBg: "dark:bg-red-500/12" },
  };

  useEffect(() => {
    const Headerlinkks = document.querySelectorAll(".headerLinks");
    const subLinks = document.querySelectorAll(".subLinks");
    const element = document.getElementById("dashboard")
    const subElement = document.getElementById("overview");

    Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
    subLinks.forEach(el => el.classList.remove("activeSubLink"));
    element?.classList.add("activeHeaderLink");
    subElement?.classList.add("activeSubLink");

    document.title = `Dashboard`;
  }, []);


  const status = ["ORDERED", "REVIEWED", "DELIVERED", "ON_HOLD", "REFUNDED", "COMMISSIONED", "COMPLETED", "REVIEW_DELETED"]

  useEffect(() => {
    dispatch(chartDataAction(dateFrom, dateTo))
    dispatch(allOrdersAction({ perPage: 5 }))
    dispatch(allProductsAction({ perPage: 5 }))
  }, [dispatch, dateFrom, dateTo])


  return (
    <Fragment>
      {(loading || orderLoading) && <></>}
      
      {/* 
        Ultra-modern, enterprise-grade minimalist theme (Vercel / Stripe inspired)
        - Zinc/Slate subdued color palette
        - Sharp, thin borders
        - Extreme typography contrast (uppercase gray labels, heavy black values)
        - High signal-to-noise ratio, zero gimmicks
      */}
      <div className="font-jakarta bg-zinc-50 dark:bg-[radial-gradient(circle_at_top_left,rgba(14,165,233,0.08),transparent_28%),linear-gradient(180deg,#020617_0%,#0b1120_45%,#0f172a_100%)] min-h-screen pb-12">
        
        {/* Sticky Header */}
        <section className="w-full px-6 lg:px-10 py-6 bg-white/95 dark:bg-slate-950/85 backdrop-blur-xl border-b border-zinc-200/80 dark:border-slate-800 shadow-[0_2px_8px_-4px_rgba(0,0,0,0.05)] flex flex-col md:flex-row justify-between items-start md:items-center sticky top-0 z-30" >
          <div className="mb-4 md:mb-0">
            <h1 className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight flex items-center gap-2" >
              Overview
              <span className="w-2 h-2 rounded-full bg-sky-500"></span>
            </h1>
            <p className="text-sm font-medium text-zinc-500 dark:text-slate-400 mt-1" >
              Welcome back, <span className="font-bold text-zinc-900 dark:text-slate-100">{user?.name}</span>. Here's what's happening.
            </p>
          </div>
          <div className="w-full md:w-auto relative z-40">
              <DateFilter
                  dateFrom={dateFrom}
                  setDateFrom={setDateFrom}
                  dateTo={dateTo}
                  setDateTo={setDateTo}
              />
          </div>
        </section>

        {/* Main Grid - Now Responsive Grid */}
        <section className="max-w-[1400px] mx-auto p-6 lg:p-10 flex flex-col gap-6 lg:gap-8">
            
            {/* Super Admin Stats Row */}
            {user?.role === "SUPER_ADMIN" && (
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <h2 className="text-base font-[800] text-zinc-900 dark:text-slate-100 tracking-tight">Super Admin Metrics</h2>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-300 uppercase">Exclusive</span>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Total Admins */}
                <div className="bg-gradient-to-br from-indigo-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border border-indigo-100/80 dark:border-indigo-400/25 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow">
                  <div>
                    <span className="text-xs font-bold text-indigo-600 dark:text-indigo-300 tracking-wider uppercase">Total Admins</span>
                    <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{chart?.userCounts?.total_admin || 0}</div>
                  </div>
                  <div className="text-right mt-2">
                    <i className="fa-solid fa-user-shield text-indigo-500 dark:text-indigo-200 text-2xl"></i>
                  </div>
                </div>

                {/* Total PMMs */}
                <div className="bg-gradient-to-br from-emerald-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border border-emerald-100/80 dark:border-emerald-400/25 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow">
                  <div>
                    <span className="text-xs font-bold text-emerald-600 dark:text-emerald-300 tracking-wider uppercase">Total PMMs</span>
                    <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{chart?.userCounts?.total_pmm || 0}</div>
                  </div>
                  <div className="text-right mt-2">
                    <i className="fa-solid fa-user-tie text-emerald-500 dark:text-emerald-200 text-2xl"></i>
                  </div>
                </div>

                {/* Total PMs */}
                <div className="bg-gradient-to-br from-amber-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border border-amber-100/80 dark:border-amber-400/25 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow">
                  <div>
                    <span className="text-xs font-bold text-amber-600 dark:text-amber-300 tracking-wider uppercase">Total PMs</span>
                    <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{chart?.userCounts?.total_pm || 0}</div>
                  </div>
                  <div className="text-right mt-2">
                    <i className="fa-solid fa-users text-amber-500 dark:text-amber-200 text-2xl"></i>
                  </div>
                </div>

              </div>
              </div>
            )}

            {/* Chart */}
            <div className="bg-white dark:bg-slate-900/80 rounded-2xl border border-zinc-200/80 dark:border-slate-800 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_18px_45px_rgba(0,0,0,0.26)] p-6 lg:p-8">
              <h2 className="text-lg font-[800] text-zinc-900 dark:text-white tracking-tight mb-8" >Revenue Details</h2>
              <GrossNetProfit currentPeriod={currentPeriod} previousPeriod={previousPeriod} dateFrom={dateFrom} user={user} />
            </div>
            {user?.role !== "PM" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Active Products */}
                <div className="bg-gradient-to-br from-sky-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border border-sky-100/80 dark:border-sky-400/25 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow">
                  <div>
                    <span className="text-xs font-bold text-sky-600 dark:text-sky-300 tracking-wider uppercase">Active Products</span>
                    <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{chart?.activeProducts || 0}</div>
                  </div>
                  <div className="text-right mt-2">
                    <i className="fa-solid fa-box-open text-sky-500 dark:text-sky-200 text-2xl"></i>
                  </div>
                </div>

                {/* Active Orders */}
                <div className="bg-gradient-to-br from-indigo-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border border-indigo-100/80 dark:border-indigo-400/25 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow">
                  <div>
                    <span className="text-xs font-bold text-indigo-600 dark:text-indigo-300 tracking-wider uppercase">Active Orders</span>
                    <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{chart?.activeOrders || 0}</div>
                  </div>
                  <div className="text-right mt-2">
                    <i className="fa-solid fa-clipboard-list text-indigo-500 dark:text-indigo-200 text-2xl"></i>
                  </div>
                </div>
              </div>
            )}

            {/* Orders By Status */}
            <div className="bg-white dark:bg-slate-900/80 rounded-2xl border border-zinc-200/80 dark:border-slate-800 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_18px_45px_rgba(0,0,0,0.26)] p-6 lg:p-8">
              <h2 className="text-base font-[800] text-zinc-900 dark:text-white tracking-tight mb-6">Order Status</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {status.map((item, index) => {
                  const currentVal = currentPeriod?.statusCounts?.[item] || 0;
                  const prevVal = previousPeriod?.statusCounts?.[item] || 0;
                  const diff = currentVal - prevVal;
                  
                  return (
                    <div key={index} 
                      className={`bg-gradient-to-br ${statusStyles[item]?.gradient || "from-zinc-50/50 to-white"} dark:from-transparent dark:to-transparent dark:bg-slate-950/70 rounded-2xl border ${statusStyles[item]?.border || "border-zinc-100/80"} dark:border-slate-700 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] p-6 flex flex-col justify-between hover:shadow-md transition-shadow animate-[fadeIn_0.3s_ease-out]`}
                      style={{ animationDelay: `${index * 50}ms`, animationFillMode: "backwards" }}
                    >
                      <div>
                        <div className="flex justify-between items-center">
                          <span className={`text-xs font-bold ${statusStyles[item]?.text || "text-zinc-600 dark:text-slate-300"} tracking-wider uppercase truncate`}>
                            {item.replaceAll("_", " ")}
                          </span>
                          <span className={`text-xs font-[800] ${diff > 0 ? "text-emerald-600 dark:text-emerald-300" : diff < 0 ? "text-rose-600 dark:text-rose-300" : "text-zinc-300 dark:text-slate-600"}`}>
                            {diff > 0 ? `↑ ${diff}` : diff < 0 ? `↓ ${Math.abs(diff)}` : ""}
                          </span>
                        </div>
                        <div className="text-3xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1">{currentVal}</div>
                      </div>
                      <div className="text-right mt-2">
                        <span className={`inline-grid h-11 w-11 place-items-center rounded-2xl ${statusStyles[item]?.iconBg || "dark:bg-slate-800"}`}>
                          <i className={`fa-solid ${statusStyles[item]?.icon || "fa-circle"} ${statusStyles[item]?.iconColor || "text-zinc-300 dark:text-slate-500"} text-xl`}></i>
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
        </section>

        {/* Tables Section */}
        <section className="max-w-[1600px] mx-auto px-6 lg:px-10 flex flex-col gap-8">
          <div className="bg-white dark:bg-slate-900/80 rounded-2xl border border-zinc-200/80 dark:border-slate-800 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_18px_45px_rgba(0,0,0,0.26)] overflow-hidden">
             <Products products={products} user={user} />
          </div>
          <div className="bg-white dark:bg-slate-900/80 rounded-2xl border border-zinc-200/80 dark:border-slate-800 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.04)] dark:shadow-[0_18px_45px_rgba(0,0,0,0.26)] overflow-hidden">
             <OrdersPage orders={orders} user={user} />
          </div>
        </section>

      </div>
    </Fragment>
  );
};

export default Dashboard;
